<!-- Desktop Header -->
<div class="hidden flex-col lg:flex" (click)="closeModal()">
  <nav raNavbar></nav>
  <div raHeaderDesktop></div>
</div>

<!-- Mobile Header -->
<div class="grid lg:hidden" (click)="closeModal()">
  <div raHeaderMobile></div>
</div>
